import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from 'config/config';
import checkOrSetSlash from 'utils/checkOrSetSlash';
import { prepareFCHeader } from 'utils/request';

const baseUrl = `${checkOrSetSlash(config.apiHostGateway, 'apiHostGateway')}api/`;

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => prepareFCHeader()(headers, { getState }), // call for each request
  }),
  tagTypes: [
    'Activities',
    'BusinessPrioritiesList',
    'Categories',
    'Companies',
    'ContractInfo',
    'DeletedOrganizationsList',
    'Document',
    'DocumentsList',
    'FormAutomations',
    'DynamicProperties',
    'Forms',
    'FormsLibrary',
    'GroupMembers',
    'IntegrationSettings',
    'LinkedForms',
    'KolimmoUsers',
    'Meeting',
    'MeetingsList',
    'Modules',
    'Notes',
    'Offers',
    'Organization',
    'OrganizationFormTemplates',
    'OrganizationMembers',
    'OrganizationRoles',
    'OrganizationStatusesList',
    'OrganizationsList',
    'Phase',
    'GroupContent',
    'Plan',
    'Plans',
    'Project',
    'ProjectMembersList',
    'ProjectNonMembersList',
    'ProjectRoles',
    'ProjectStatusesGroupedByForms',
    'ProjectStatusesList',
    'Stakeholders',
    'SuperAdminPrioritiesList',
    'Tenants',
    'Trades',
    'User',
    'WorkspaceFormTemplates',
    'WorkspaceMembersList',
    'WorkspacePrioritiesList',
    'WorkspacesList',
    'WorkspaceStatusesList',
  ],
  endpoints: () => ({}),
});
